import axios from 'axios';

/**
 * @return {AxiosInstance}
 */
const instanceAxios = axios.create({
    baseURL: process.env.VUE_APP_DOMAIN_URL,
    headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    }
});

const instanceAxiosMiddleware = axios.create({
    baseURL: process.env.VUE_APP_DOMAIN_URL_MIDDLEWARE,
    headers: {
        Authorization: "Bearer " + process.env.VUE_APP_TOKEN_MIDDLEWARE,
        "Content-Type": "application/json",
    }
});

export default class InternalAPI {
    constructor() {
        /**
         *
         * @type {AxiosInstance}
         */
        this.$axios = instanceAxios
        this.$axiosMiddleware = instanceAxiosMiddleware
    }

    /**
     *
     * @param data {object|null|unknown}
     * @return {string|unknown}
     */
    setErrorMessage(data) {
        if (typeof data === 'object') {
            const getValues = Object.values(data)
            if (getValues.length > 0 && getValues[0] !== "") {
                return getValues[0]["en"] || getValues[0]["id"] || getValues[0]["desc"]["en"] ||
                    getValues[0]["desc"]["id"] || "something went wrong"
            }
            return "unknown message obj"
        }

        if (typeof data === 'string') {
            if (data !== "") {
                return data
            }
            return "unknown message str"
        }

        return "unknown message type"
    }
}
